import React, { Component } from "react";
import { Row } from "react-bootstrap";
import icon1 from "../Images/cite/icon1.png";
import icon2 from "../Images/cite/icon2.png";
import icon3 from "../Images/cite/icon3.png";
import icon4 from "../Images/cite/icon4.png";
import icon5 from "../Images/cite/icon5.png";
import icon6 from "../Images/cite/icon6.png";
import icon7 from "../Images/cite/icon7.png";

import Content from "./Content";

export default class ItemModal extends Component {
  contents = [
    {
      pic: icon1,
      text: "تولید استناد درون متن و کتابنامه",
      full_text:
        "با استفاده از شیوه‌نامه‌های مورد نظر می‌توانید هم استناد درون متن و هم برون متن تولید کنید."
    },
    {
      pic: icon2,
      text: "انتخاب چندین شیوه‌نامه",
      full_text:
        "ساخت استناد با استفاده ازشیوه‌های APA ، MLA، شیکاگو یا هر یک از شیوه‌نامه‌های دیگر"
    },
    {
      pic: icon3,
      text: "ورود اطلاعات به‌صورت دستی",
      full_text:
        "اطلاعات ضروری استناد آیتم مورد نظر را در فیلدهای مشخص پر کنید تا با شیوه‌نامه دلخواه استناد تولید شود."
    },
    {
      pic: icon4,
      text: "امکان ویرایش استناد و کتابنامه",
      full_text:
        "پس از اضافه کردن یک آیتم، ممکن است لازم باشد چند فیلد را اضافه یا تغییر دهید. برای ویرایش اطلاعات، بر روی آیکن ویرایش در بخش تنظیمات کلیک کنید."
    },
    {
      pic: icon5,
      text: "ذخیره خودکار استناد",
      full_text:
        "به طور خودکار کتابنامه در  فضای محلی مرورگر شما ذخیره می‌شود. شما می‌توانید صفحه را ببندید و در هر زمان به آن بازگردید. (اگر شما در مرورگر خود از حالت خصوصی / حالت ناشناس استفاده می کنید، در هنگام بستن پنجره، کتابشناسی شما پاک می شود.)"
    },
    {
      pic: icon6,
      text: "امکان صدور کتابنامه",
      full_text:
        "در صورت نیاز می‌توانید کتابنامه را به کلیپ بورد کپی کنید. شما همچنین می‌توانید HTMLبا استفاده از دکمه دریافت خروجی، برای افزودن به یک صفحه وب، یک سند RTF برای باز کردن در word یا یک فایل RIS یا BibTeX برای وارد کردن به یک استناد استفاده کنید."
    },
    {
      pic: icon7,
      text: "کپی استناد و کتابنامه",
      full_text:
        "همانطور که در حال نوشتن هستید، می‌توانید سریعاً استنادهای مشخص شده شده را با کپی کردن به پایان نامه ، یا سند خود وارد کنید."
    },
    {
      pic: icon1,
      text: "اطالاعات بیشتر",
      full_text: (
        <a target="_blunk" href="https://pajoohyar.ir/blog/post/1564">
          اخبار استنادهی آنلاین
        </a>
      )
    }
  ];
  render() {
    return (
        <Row className="cite__myGridItem1 mx-0">
          {this.contents.map((item, index) => (
            <Content key={`content-${index}`} data={item} />
          ))}
        </Row>
    );
  }
}
